angular.module('core')
  .service('mediaQuery', ['$rootScope', '$window', '$timeout', function($rootScope, $window, $timeout) {
    var self = this;
    self.desktopWidth = 1365;
    self.mobileWidth = 900;

    /* updateWindowSize
     * One directive that updates screen size on the rootScope so you only have to watch
     * the _height or _width object for changes.
     */
    self.updateWindowSize = function() {
      $rootScope._width = parseInt($window.innerWidth);
      $rootScope._height = parseInt($window.innerHeight);
    };

    self.updateWindowSize();

    angular.element($window).bind('resize', function() {
      self.updateWindowSize();
      $rootScope.$apply();
    });

  }]);
